export class ContractorFileCreateRequest {

    _name; // string,
    _file; // string

    constructor(values) {
        this._name = values.name;
        this._file = values.file;
    }

    body() {
        return {
            name: this._name,
            file: this._file,
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/documentary-library/form/create/webservices/ContractorFileCreateRequest.js